import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';
import { Modal } from 'react-bootstrap';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
interface IInputProps {
  name: string,
  id: string,
  label: string,
  placeholder?: string,
  readonly?: boolean,
  defaultValue?: string
  disabled?: boolean
  maxLength?: number,
  handleOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any,
  isvalidateNumber?: boolean,
  isvalidateNumberPostalCode?: boolean,
  req?: string
  pattern?: RegExp,
  patternMessage?: string
  xl?: number
  md?: number
  invisible?: boolean
  modal?: string
  type?: React.InputHTMLAttributes<HTMLInputElement>['type']
}

const FormInputText: React.FC<IInputProps> = ({ modal, name, id, label, placeholder, disabled, readonly, maxLength, req, pattern, patternMessage, xl, md, invisible, defaultValue, type = 'text' }) => {

  //NUEVO INPUT DE TEXTO CON MEJOR MANEJO //


  const { register, formState: { errors }, setValue } = useFormContext();
  const [show, setShow] = useState(false);


  // / Obtener mensaje de error seguro
  const errorMessage = get(errors, name)?.message;


  useEffect(() => {
    if (defaultValue != null && defaultValue !== undefined && defaultValue !== "") {
      setValue(name, defaultValue);
    }

  }, []);


  return (
    <div className={`col-xl-${xl} col-md-${md} ${invisible ? 'd-none' : ''}`}>
      <div className={`input-block ${errors && errors[name]?.message ? 'error' : ''}`}>

        <div className="d-flex align-items-center justify-content-start">
          <label htmlFor={id} className="input-block__label m-0">{label}</label>
          {modal && (
            <TooltipComponent content="Más Información">
              <div onClick={() => setShow(true)} className="information-icon-orange p-0 ms-2" />
            </TooltipComponent>
          )}
        </div>

        <input
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          {...register(name, { required: req, pattern: { value: pattern, message: patternMessage } })}
          readOnly={readonly || false}
          disabled={disabled}
          maxLength={maxLength}
          style={{ cursor: disabled ? 'not-allowed' : 'auto' }}
          autoComplete='off'
          spellCheck={false}
          autoCapitalize='off'
          autoCorrect='off'
        />

        <Modal show={show} onHide={() => setShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modal}</Modal.Body>
        </Modal>

        {errorMessage && <p className="error m-0">{errorMessage as any}</p>}
      </div>
    </div>
  )
}

export default FormInputText;